module.exports = __webpack_public_path__ + "static/block2-2128e012cc18e1bae771cbb3c2b18c06.jpg";